<tui-select
  [formControl]="control.control"
  [tuiTextfieldLabelOutside]="true"
  [tuiTextfieldCleaner]="false"
  [readOnly]="!!readonly"
  [valueContent]="valueContent"
>
  <ng-container [ngTemplateOutlet]="placeholderTpl"/>
  <ng-template tuiDataList>
    <tui-data-list *ngIf="(loading$ | async | isFalse); else loadingTpl">
      <button
        *ngFor="let item of items$ | async"
        tuiOption
        [value]="item.code"
      >
        <ng-container
          [ngTemplateOutlet]="contentTpl"
          [ngTemplateOutletContext]="{ $implicit: item }"
        />
      </button>
    </tui-data-list>
    <ng-template #loadingTpl>
      <tui-loader [size]="'s'" />
    </ng-template>
  </ng-template>
</tui-select>
<ng-template #valueContent let-value>
  <ng-container
    *ngIf="items$ | async as items"
    [ngTemplateOutlet]="contentTpl"
    [ngTemplateOutletContext]="{ $implicit: items | find:value }"
  />
</ng-template>

<ng-template #placeholderTpl>
  <div class="tw-flex tw-items-center tw-justify-between">
    <span>Country</span>
    <ng-container></ng-container>
    <tui-loader *ngIf="(loading$ | async) && control.control.value" [size]="'s'" class="tw-w-[24px]" />
  </div>
</ng-template>

<ng-template #contentTpl let-item>
  <div class="tw-flex tw-items-center tw-gap-[8px]">
    <wo-country-flag [code]="item.code"/>
    <div>
      {{ item.presentedName }}
    </div>
  </div>
</ng-template>
